import { render } from "./B2bFilterButtonCommercialRelation.vue?vue&type=template&id=b08d65c4&scoped=true&lang=pug"
import script from "./B2bFilterButtonCommercialRelation.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonCommercialRelation.vue?vue&type=script&lang=js"

import "./B2bFilterButtonCommercialRelation.vue?vue&type=style&index=0&id=b08d65c4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b08d65c4"]])

export default __exports__